// extracted by mini-css-extract-plugin
module.exports = {"categories":"products-module--categories--3I9ey","title":"products-module--title--1lR4X"};